var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _ellipse, _ellipse2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1558 22.521H4.14468C4.78812 22.521 5.31458 21.9963 5.31458 21.3551V19.7812H0.98584V21.3551C0.98584 21.9963 1.5123 22.521 2.1558 22.521Z",
    fill: "#65707B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31458 21.1512H1.74631C1.45384 21.1512 1.21984 21.0918 0.98584 20.9731V19.7266H5.31453V21.1512H5.31458Z",
    fill: "#65707B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79164 9.42384H1.10835C0.466648 9.42384 0 8.89782 0 8.31333V8.19645C0 7.55355 0.524999 7.08594 1.10835 7.08594H3.7917V9.42384H3.79164Z",
    fill: "#65707B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2085 9.42384H26.8918C27.5335 9.42384 28.0002 8.89782 28.0002 8.31333V8.19645C28.0002 7.55355 27.4752 7.08594 26.8918 7.08594H24.2085V9.42384Z",
    fill: "#65707B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6456 0.830942C16.6289 -0.276981 11.3789 -0.276981 6.30392 0.830942C5.02056 1.12248 3.97056 2.347 3.67891 3.74646C3.03726 6.83691 2.39556 9.75249 1.75391 12.4931C9.86228 12.4931 18.029 12.4931 26.1373 12.4931C25.4957 9.75249 24.854 6.83691 24.2123 3.74646C23.979 2.40533 22.8706 1.12248 21.6456 0.830942Z",
    fill: "#65707B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0542 8.54555C23.7627 7.14699 23.4129 5.63191 23.0631 4.00024C22.8882 3.06785 22.1303 2.19375 21.3725 2.01893C18.924 1.49447 16.4754 1.20312 13.9686 1.20312C13.5605 1.20312 13.2107 1.20312 12.8026 1.20312C12.2196 1.20312 11.6367 1.26142 10.9954 1.31965C10.4124 1.37794 9.82942 1.43618 9.24642 1.49447C8.83831 1.55276 8.43026 1.611 8.02215 1.66929C7.61405 1.84411 7.08936 1.96064 6.62299 2.07722C5.8651 2.25204 5.1072 3.06785 4.9323 4.00024C4.81573 4.69952 4.64083 5.3988 4.5242 6.03978C4.40762 6.62253 4.29099 7.20523 4.17441 7.72969C4.11609 8.02103 4.05783 8.25415 3.99951 8.54549H24.0542V8.54555Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1211 20.2706H1.73957C0.922983 20.2706 0.281329 19.511 0.398023 18.6931V13.0841C0.514663 12.3245 0.864636 11.6234 1.3896 11.0976C2.14789 10.2212 3.2561 9.69531 4.42272 9.69531H23.4379C24.6628 9.69531 25.7711 10.2212 26.471 11.0976C26.9376 11.6234 27.2876 12.3245 27.4043 13.0841V18.6931C27.6376 19.511 26.996 20.2706 26.1211 20.2706Z",
    fill: "#65707B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5897 20.2209H1.73601C0.921567 20.2209 0.2816 19.4632 0.397987 18.6473V13.052C0.51432 12.2943 0.863373 11.5949 1.38695 11.0703C5.86645 12.1777 9.24065 15.4999 9.5897 20.2209Z",
    fill: "#65707B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7882 22.521H23.7993C23.1559 22.521 22.6294 21.9963 22.6294 21.3551V19.7812H26.9581V21.3551C26.9581 21.9963 26.4317 22.521 25.7882 22.521Z",
    fill: "#65707B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5752 21.1512H26.1435C26.4359 21.1512 26.6699 21.0918 26.9039 20.9731V19.7266H22.5752V21.1512Z",
    fill: "#65707B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.133 20.2209H18.3008C18.6515 15.4416 22.0415 12.1194 26.5421 11.0703C27.0096 11.5949 27.3603 12.2943 27.4773 13.052V18.6473C27.6526 19.4632 27.0097 20.2209 26.133 20.2209Z",
    fill: "#65707B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.49539,
    cy: 16.6159,
    rx: 2.0408,
    ry: 2.04563,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4461,
    cy: 16.6159,
    rx: 2.0408,
    ry: 2.04563,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.1509,
    y: 15.1562,
    width: 7.63846,
    height: 2.80546,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommute);
export default ForwardRef;